import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal, openModalWithData } from "@store/slices/modalSlice";
import type { RootState } from "@store/store";
import type { AppDispatch } from "@store/store";

export const useModal = () => {
	const dispatch = useDispatch<AppDispatch>();
	const modalState = useSelector((state: RootState) => state.modal);

	const openModalAction = (modalKey: keyof RootState["modal"]) => {
		dispatch(openModal(modalKey));
	};

	const closeModalAction = (modalKey: keyof RootState["modal"]) => {
		dispatch(closeModal(modalKey));
	};

	const openModalWithDataAction = (modalKey: keyof RootState["modal"], data?: unknown) => {
		dispatch(openModalWithData({ modalKey, data }));
	};

	return {
		modalState,
		openModal: openModalAction,
		closeModal: closeModalAction,
		openModalWithData: openModalWithDataAction,
	};
};
